module.exports = __webpack_public_path__ + "img/img_locker_cancel.dec4d591.png";